/**
 * Elder Ray Index (Bull / Bear Power)
 *
 * Bull Power = High − EMA(close, period)
 * Bear Power = Low − EMA(close, period)
 *
 * Category: Momentum | Pane: Separate
 */
import { IndicatorDefinition, PlotData } from "../types/indicator.types";
import { CandleData } from "../../types/chart.types";
import { computeEMA } from "./sma";

export const elderRayIndicator: IndicatorDefinition = {
  id: "elder_ray",
  name: "Elder Ray Index",
  shortName: "ElderRay",
  category: "momentum",
  pane: "separate",
  params: [
    { key: "period", label: "Period", type: "number", default: 13, min: 2, max: 100 },
  ],
  plots: [
    { key: "bull", label: "Bull Power", color: "#4CAF50", style: "histogram", lineWidth: 2 },
    { key: "bear", label: "Bear Power", color: "#F44336", style: "histogram", lineWidth: 2 },
  ],
  calculate: (candles: CandleData[], params: Record<string, any>): PlotData[] => {
    const { period } = params;
    const closes = candles.map(c => c.close);
    const ema = computeEMA(closes, period);
    const bullData: { time: number; value: number }[] = [];
    const bearData: { time: number; value: number }[] = [];

    for (let i = 0; i < candles.length; i++) {
      if (ema[i] !== undefined) {
        bullData.push({ time: candles[i].time, value: candles[i].high - ema[i] });
        bearData.push({ time: candles[i].time, value: candles[i].low - ema[i] });
      }
    }

    return [
      { key: "bull", data: bullData },
      { key: "bear", data: bearData },
    ];
  },
};
